"use client";

import { NextIntlClientProvider } from "next-intl";
import type { AbstractIntlMessages } from "next-intl";
import type { ReactNode } from "react";
import { QueryProvider } from "./QueryProvider";
import { StaleChunkReloader } from "./StaleChunkReloader";
import { AccessRestrictedModal } from "./AccessRestrictedModal";
import { configureCdnIcons } from "@westayltd/icons";

configureCdnIcons({ cdnBaseUrl: "" });

type AppProvidersProps = {
  children: ReactNode;
  locale: string;
  messages: AbstractIntlMessages;
};

import { Toaster } from "sonner";

/**
 * Client-side app providers (i18n + TanStack Query).
 * React Hook Form + Zod are used per-form; see lib/forms/setup.ts.
 */
export function AppProviders({
  children,
  locale,
  messages,
}: AppProvidersProps) {
  return (
    <NextIntlClientProvider locale={locale} messages={messages} timeZone="UTC">
      <QueryProvider>
        <StaleChunkReloader />
        <AccessRestrictedModal />
        {children}
        <Toaster richColors position="bottom-right" />
      </QueryProvider>
    </NextIntlClientProvider>
  );
}
